import React, { useState } from 'react';
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';

import Autosuggest from "react-autosuggest";

/**
 * 
 * @param {*} props 
 * {
 *      className: string    
 * 
 *      placeholder: string
 *      label="name" 
 * 
 *      keywords=
 *      options={_diagnosisHints} 
 *  
 *      onChange(newKeywords) - callback when user changes keywords
 * }
 * @returns 
 */
function CriteriaKeywords(props) {
  const { t } = useTranslation();
  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  // filter hints based on user input
  const getSuggestions = (inputValue) => {
    const query = inputValue.trim().toLowerCase();
    if (!query) 
        return [];
    return props.searchHints.filter((hint) =>
        hint.toLowerCase().includes(query)
    );
  };

  const getSuggestionValue = (suggestion) => suggestion;

  const renderSuggestion = (suggestion) => (
    <div className="px-2 py-1 hover:bg-gray-100 cursor-pointer">
      {suggestion}
    </div>
  );

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value));
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const inputProps = {
    placeholder: props.placeholder || t('Enter keywords...'),
    value, // TODO: replace on props.keywords and remove value state
    onChange: (_event, { newValue }) => {
        //console.log(`CriteriaKeywords.inputProps.onChange(): newValue:`, newValue);
        setValue(newValue);
        if (props.onChange) {
            props.onChange(newValue);
        }
    },
  };

  return (
    <div className={`${props.className} criteria-keywords`}> 
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    </div>
  );
}

export default CriteriaKeywords;
